import ReactDatepicker, { registerLocale } from 'react-datepicker';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { enUS, es, pt } from 'date-fns/locale';
import type { ComponentProps } from 'react';

//:horizon://import 'react-datepicker/dist/react-datepicker.css';

registerLocale(I18nLocale.EN, enUS);
registerLocale(I18nLocale.ES, es);
registerLocale(I18nLocale.PT, pt);

export function ReactDatePickerWrapper(
  props: ComponentProps<typeof ReactDatepicker>,
) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ReactDatepicker {...props} />;
}
